import HTMLView from './HTMLView';
import MathJax from './MathJax'; // MathJax can render both HTML and LaTex

export default HTMLView;
